import { Button } from "@/components/ui/buttons/Button";

type Props = {
    isToggled: boolean;
    label: string;
    toggle: () => void;
    disabled?: boolean;
};

const Toggle = (props: Props) => {
    const { isToggled, label, toggle, disabled } = props;

    return (
        <Button variant={isToggled ? "primary" : "outline"} onClick={toggle} disabled={disabled}>
            {label}
        </Button>
    );
};

export { Toggle };
export type { Props as ToggleProps };
